<template>
  <div class="container">
    <div v-if="isLoading" class="loading-screen">
      <div class="spinner"></div>
      <p>جاري التحميل...</p>
    </div>

    <h1>قائمة مناظرات سلك التنفيذ</h1>

    <div class="table-responsive">
      <table class="custom-table">
        <thead>
          <tr>
            <th>رمز المناظرة</th>
            <th>خطة المناظرة</th>
            <th>عدد الخطط</th>
            <th>مركز العمل</th>
            <th>المستوى التعليمي والاختصاص</th>
            <th>التسجيل</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>25/24</td>
            <td>أعوان إطفاء</td>
            <td>06</td>
            <td>بنزرت</td>
            <td>مستوى دراسي من سنة 9 أساسي  منهاة بنجاح إلى سنة أولى ثانوي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/24')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/25</td>
            <td>اعوان حراسة</td>
            <td>18</td>
            <td>بنزرت</td>
            <td>مستوى دراسي من سنة 6 أساسي منهاة بنجاح إلى سنة 08 أساسي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/25')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/26</td>
            <td>عون حراسة</td>
            <td>01</td>
            <td>تونس</td>
            <td>مستوى دراسي من سنة 6 أساسي  منهاة بنجاح إلى سنة 08 أساسي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/26')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/27</td>
            <td>عمال مؤهلون</td>
            <td>06</td>
            <td>بنزرت</td>
            <td>شهادة الكفاءة المهنية (CAP) في اختصاص لحام أو البناء المعدني مُنظرة بالمستوى الثاني من السُلّم الوطني للمهارات أو مستوى سنة 2 ثانوي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/27')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/28</td>
            <td>عمال مؤهلون</td>
            <td>14</td>
            <td>بنزرت</td>
            <td>شهادة الكفاءة المهنية (CAP) في اختصاص  ميكانيك مُنظرة بالمستوى الثاني من السُلّم الوطني للمهارات أو مستوى سنة 2 ثانوي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/28')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/29</td>
            <td>عمال مؤهلون</td>
            <td>06</td>
            <td>بنزرت</td>
            <td>شهادة الكفاءة المهنية (CAP) في اختصاص  Electrique مُنظرة بالمستوى الثاني من السُلّم الوطني للمهارات أو مستوى سنة 2 ثانوي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/29')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/30</td>
            <td>عمال مؤهلون</td>
            <td>09</td>
            <td>بنزرت</td>
            <td>مستوى السنة الثانية ثانوي منهاة بنجاح (نظام جديد)</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/30')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/31</td>
            <td>عمال مختصون</td>
            <td>09</td>
            <td>بنزرت</td>
            <td>مستوى دراسي 09 أساسي منهاة بنجاح نظام جديد</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/31')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/32</td>
            <td>عمال</td>
            <td>15</td>
            <td>بنزرت</td>
            <td>مستوى دراسي السنة السادسة أساسي منهاة بنجاح</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/32')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/33</td>
            <td>عامل</td>
            <td>01</td>
            <td>تونس</td>
            <td>مستوى دراسي السنة السادسة أساسي منهاة بنجاح</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/33')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/34</td>
            <td>سائق</td>
            <td>02</td>
            <td>بنزرت</td>
            <td>09  أساسي منهاة بنجاح (نظام جديد) + رخصة سياقة B+C+D </td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/34')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/35</td>
            <td>سائق</td>
            <td>01</td>
            <td>تونس</td>
            <td>09 أساسي منهاة بنجاح (نظام جديد) + رخصة سياقة B+C+D</td>
            <td>
              <router-link 
                to="/formcom" 
                class="register-btn" 
                @click.prevent="setExamId('25/35')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecruitmentTable",
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    setTimeout(() => {
      const loadingScreen = document.querySelector('.loading-screen');
      if (loadingScreen) {
        loadingScreen.style.transition = 'opacity 0.8s ease';
        loadingScreen.style.opacity = '0';
        setTimeout(() => {
          this.isLoading = false;
        }, 800);
      }
    }, 2000);
  },
  methods: {
    setExamId(id) {
      localStorage.setItem('examId', id);
      console.log('ID saved in localStorage:', id); // باش تشوف القيمة مباشرة
      this.$router.push('/formcom');
    }
  }
};
</script>

<style scoped>
:root {
  --primary: #0055a5;
  --primary-light: #0077cc;
  --accent: #ffd700;
}

.container {
  direction: rtl;
  padding: 20px;
  font-family: Arial, sans-serif;
  background: #f4f4f4;
  min-height: 100vh;
}

.loading-screen {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, var(--primary), var(--primary-light));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255,255,255,0.3);
  border-top: 4px solid var(--accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.table-responsive {
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ccc;
  padding: 10px;
  vertical-align: top;
  text-align: center;
}

.custom-table th {
  background: #0055a5;
  color: white;
  font-weight: bold;
}

.custom-table tbody tr:nth-child(even) {
  background: rgba(0, 85, 165, 0.05);
}

.custom-table tbody tr:hover {
  background: #e6f0ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,85,165,0.2);
  transition: all 0.3s ease;
}

.register-btn {
  display: inline-block;
  background: linear-gradient(45deg, #0055a5, #ffd700);
  color: #fff;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 12px;
  text-decoration: none;
  box-shadow: 0 5px 15px rgba(0, 85, 165, 0.3);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.register-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 85, 165, 0.4);
  text-decoration: none;
}

.register-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: skewX(-25deg);
  transition: all 0.5s ease;
}

.register-btn:hover::after {
  left: 200%;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-table th,
  .custom-table td {
    padding: 8px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .custom-table th,
  .custom-table td {
    padding: 6px;
    font-size: 0.8rem;
  }
}
</style>
